export default {
  hero: {
    eyebrow: 'Universal promo codes',
    title: 'Win the guests who aren’t in your loyalty program — yet.',
    body_prefix:
      'Create one promotional code that works everywhere you sell — online, in-app, and at the register — then track it all in one place. ',
    body_emphasis: 'No loyalty account required',
    body_suffix:
      ', which makes promo codes built for acquisition: paid ads, direct mail, partnerships, and broad-reach campaigns aimed at people you don’t know yet.',
    points: {
      acquisition: {
        lead: 'Acquisition-first.',
        rest: 'No app download or signup needed — reach people who’ve never bought from you.',
      },
      everywhere: {
        lead: 'Everywhere you sell.',
        rest: 'Online, in-app, and at the register, all from one code.',
      },
      measurable: {
        lead: 'Fully measurable.',
        rest: 'Track redemptions, revenue, and channel breakdown in Rewards reporting.',
      },
    },
    learn_more: 'Learn more',
    animation_alt:
      'A promo code arrives by mail, is entered at mobile checkout, and takes $10 off the order total.',
    animation: {
      merchant: 'supergreens',
      offer_headline: '$10 OFF',
      offer_sub: 'your order',
      promo_code: '9KX2Q7WB3F',
      status_time: '9:41',
      checkout: 'Checkout',
      items: {
        bowl: 'Green bowl',
        salad: 'Kale Caesar',
      },
      promo_label: 'Promo code',
      promo_placeholder: 'Promo code',
      apply: 'Apply',
      item_total: 'Item Total',
      discount_label: '%{code} promo code',
      discount_amount: '–%{amount}',
      total: 'Total',
      place_order: 'Place order',
    },
  },
  comparison: {
    title: 'How is this different from Loyalty Rewards?',
    promo_codes: {
      title: 'Universal promo codes',
      subtitle: 'For guests you don’t know yet',
      who_it_reaches: 'Anyone with the code – no loyalty account needed',
      best_for: 'Acquisition: ads, direct mail, partnerships, broad reach',
      distribution:
        'External channels – CSV export, SMS/email integrations, print/mail campaigns',
      attribution: 'By code & channel; member earns points on the rest',
      security:
        'Redemption validated by Thanx, but one consumer can use multiple codes across multiple purchases',
    },
    loyalty_rewards: {
      title: 'Loyalty rewards',
      subtitle: 'For members you already know',
      who_it_reaches: 'Known members in your loyalty program / CRM',
      best_for: 'Retention: re-engaging and rewarding existing guests',
      distribution: 'Issued to a member’s account; visible at checkout',
      attribution: 'Full identity',
      security: 'Thanx enforces per-account reward restrictions',
    },
    rows: {
      who_it_reaches: 'Who it reaches',
      best_for: 'Best for',
      distribution: 'Distribution',
      attribution: 'Attribution',
      security: 'Security',
    },
    guidance:
      'Already have the guest’s email or phone? Issue a reward to their account for full attribution – save promo codes for audiences you can’t reach directly.',
  },
  where_it_works: {
    title: 'Where promo codes work',
    online: {
      title: 'Online & in-app ordering',
      description: 'Guests apply the code at checkout.',
      empty: 'No ordering provider is connected to your account yet.',
    },
    instore: {
      title: 'In-store at the register (POS)',
      description:
        'Guests redeem through your POS loyalty integration. QR supported.',
      empty:
        'No point of sale is connected to your account yet. Contact us to set up your POS.',
    },
    states: {
      live: 'Supported',
      coming_soon: 'Coming soon',
      needs_activation: 'Needs activation',
      not_supported: 'Not supported',
    },
    needs_activation_notice:
      '%{provider} has to switch this on before guests can redeem (takes 10–14 weeks to complete)',
    activate: 'Activate',
    activate_aria: 'Activate promo codes for %{provider}',
    cashier_walkthrough: 'Cashier walkthrough',
    cashier_walkthrough_aria: 'Cashier walkthrough for %{provider}',
    footnote:
      'In-store redemption runs through your POS loyalty integration, and long unique codes are best redeemed as a scannable barcode or QR.',
    footnote_link: 'See the cashier walkthroughs',
  },
  // Appended to the accessible name of controls that open a new tab/window
  // (WCAG 3.2.2), shared across the overview's "Learn more" and cashier-
  // walkthrough buttons.
  opens_in_new_window: '(opens in new window)',
  code_types: {
    title: 'Single use and static codes',
    body: 'Create exportable one-time use codes in batch or set a static code, either of which can be shared broadly across channels and promotions.',
    image_alt:
      'The Thanx dashboard promo code builder beside a guest’s mobile cart with a promo code applied.',
  },
  footer_cta: {
    title: 'Create your promo code',
    body: 'Create new promo codes to drive customer acquisition.',
  },
}
